import SignupFormProvider from '@jetshop/core/components/Auth/SignupFormContainer';
import useAuth from '@jetshop/core/components/AuthContext/useAuth';
import t, { Intl } from '@jetshop/intl';
import React from 'react';
import { styled } from 'linaria/react';
import { Redirect } from 'react-router';
import BaseMaxWidth from '../../Layout/MaxWidth';
import LoadingPage from '../../LoadingPage';
import { smallCaps } from '../../ui/Headings';
import { activeSegment, smallSection } from '../UI/Form';
import Address from './Address';
import LoginFields from './LoginFields';
import { useShopConfig } from '@jetshop/core/hooks/useShopConfig';
import Head from '@jetshop/core/components/Head';
import InputWithLabel, { Input, Label } from '../../Forms/Input';
import { Field } from 'formik';
import { theme } from '../../Theming/Theming';
import { useContext } from 'react';
import SiteContentContext from '../../SiteContent/SiteContentContext';

const MaxWidth = styled(BaseMaxWidth)`
  align-items: center;
  .heading {
    ${smallCaps};
  }

  p {
    line-height: 1.5;
    font-size: 0.875rem;
    margin-bottom: 1rem;
  }

  button {
    width: 100%;
    max-width: 100%;
  }

  .hint {
    margin-top: 0.5rem;
    font-style: italic;
    font-size: 0.75rem;
    text-align: center;
  }

  .signup-info {
    *:last-child {
      margin-bottom: 0;
    }
  }

  .section {
    ${activeSegment};
    :before {
      opacity: 0;
    }
    margin-bottom: 2rem;
    transition: opacity 0.6s ease;
    opacity: 0.5;

    &.active {
      opacity: 1;
      ::before {
        opacity: 1;
      }
    }
  }
  .label-custom {
    font-size: 12px;
  }
`;

function SignUpPage() {
  const { loggedIn } = useAuth();
  const { routes } = useShopConfig();
  const { SignupText: item } = useContext(SiteContentContext);

  if (loggedIn) {
    return <Redirect to={routes.myPages.path} />;
  }

  return (
    <SignupFormProvider LoadingComponent={<LoadingPage />}>
      <MaxWidth style={{ marginTop: '2em' }}>
        <Intl>{t => <Head data={{ title: t('Signup') }} />}</Intl>
        <section className={smallSection}>
          {item?.show ? (
            <div className="signup-info">{item?.html}</div>
          ) : (
            <h1 className="heading">{t('Sign up')}</h1>
          )}
          <Address />
          {theme.config.routes.myPages.showAccessCode &&
            theme.config.routes.myPages.showMemberCode && (
              <h1 className="heading">{t('Member codes')}</h1>
            )}
          <Intl>
            {t => (
              <>
                {theme.config.routes.myPages.copyAccesCode ? (
                  <>
                    <Field name="priceListAccessCode">
                      {({ field, form }) => (
                        <>
                          <Label htmlFor={'priceListAccessCode'}>
                            <span>{t('Register code')}</span>
                          </Label>
                          <Input
                            {...field}
                            onChange={event => {
                              field.onChange(event);
                              form.setFieldValue(
                                'dynamicContent',
                                JSON.stringify({
                                  accessCode: event.target.value,
                                  created: Date.now().toString()
                                })
                              );
                            }}
                            name="priceListAccessCode"
                          />
                        </>
                      )}
                    </Field>
                  </>
                ) : (
                  <>
                    {theme.config.routes.myPages.showAccessCode && (
                      <InputWithLabel
                        type="text"
                        name="priceListAccessCode"
                        label={t('Register code')}
                      />
                    )}
                    {theme.config.routes.myPages.showMemberCode && (
                      <InputWithLabel
                        type="text"
                        name="externalId"
                        label={t('Member number')}
                      />
                    )}
                  </>
                )}
              </>
            )}
          </Intl>
          <LoginFields />
        </section>
      </MaxWidth>
    </SignupFormProvider>
  );
}

export default SignUpPage;
